class TrustStrip {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.trust-strip__track');
    this.items = el.querySelectorAll('.trust-strip__item');
    this.dashes = el.querySelectorAll('.trust-strip__dash');
    this.speed = parseInt(el.dataset.autoplay, 10) || 0;
    this.current = 0;
    this.timer = null;
    this.startX = 0;

    if (this.items.length <= 1) return;

    this.dashes.forEach((dash, i) => {
      dash.addEventListener('click', () => this.goTo(i));
    });

    this.track.addEventListener('touchstart', (e) => this.onTouchStart(e), { passive: true });
    this.track.addEventListener('touchend', (e) => this.onTouchEnd(e));

    this.mediaQuery = window.matchMedia('(min-width: 769px)');
    this.mediaQuery.addEventListener('change', () => this.handleViewportChange());
    this.handleViewportChange();
  }

  handleViewportChange() {
    if (this.mediaQuery.matches) {
      this.stopAutoplay();
    } else {
      this.startAutoplay();
    }
  }

  goTo(index) {
    this.current = (index + this.items.length) % this.items.length;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dashes.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
  }

  next() {
    this.goTo(this.current + 1);
  }

  startAutoplay() {
    if (!this.speed || this.timer) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    clearInterval(this.timer);
    this.timer = null;
  }

  onTouchStart(e) {
    this.startX = e.touches[0].clientX;
    this.stopAutoplay();
  }

  onTouchEnd(e) {
    const diff = this.startX - e.changedTouches[0].clientX;
    if (diff > 40) this.next();
    else if (diff < -40) this.goTo(this.current - 1);
    this.handleViewportChange();
  }
}

document.querySelectorAll('.trust-strip').forEach((el) => new TrustStrip(el));